export const initializeLinkList = () => {
  const blocks = document.querySelectorAll('[data-component="link-list"]')

  blocks.forEach(block => {
    const items = Array.from(block.querySelectorAll('[data-component="link-list-item"]'))
    const filterButtons = block.querySelectorAll('[data-component="link-list-filter"]')

    const render = activeCategory => {
      items.forEach(item => {
        const categories = (item.dataset.categories || '').split(',').filter(Boolean)
        const match = !activeCategory || categories.includes(activeCategory)
        item.classList.toggle('hidden', !match)
      })
    }

    filterButtons.forEach(button => {
      button.addEventListener('click', () => {
        filterButtons.forEach(btn => {
          btn.dataset.active = btn === button ? 'true' : 'false'
        })

        render(button.dataset.category || '')
      })
    })
  })
}
